define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../models/UserContext", "../../models/EmployeeModel", "../../utils/LookupDataSources"], function (require, exports, $, ko, log, tools, UserContext, EmployeeModel, LookupDataSources) {
    "use strict";
    var EmployeeActions = /** @class */ (function () {
        function EmployeeActions() {
            this.userCanEditEmployee = ko.observable(UserContext.hasAccess("Admin,Employee.Edit,Employee.Delete"));
            this.userCanDeleteEmployee = ko.observable(UserContext.hasAccess("Admin,Employee.Delete"));
            this.editModel = ko.observable(new EmployeeModel());
        }
        EmployeeActions.prototype.editEmployee = function (id) {
            var self = this;
            var title = "Add New Member";
            if (!isNaN(id)) {
                title = "Edit Member";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    self.editModel().Status(self.employeeStatusDropdown.value());
                    self.editModel().Positions(self.employeePositionDropdown.value());
                    if (!self.editModel().CompanyName() && !self.editModel().FirstName() && !self.editModel().LastName()) {
                        tools.error("Member name or Company name is a required field");
                        return;
                    }
                    //validate form
                    if (!self.editModel().CompanyName() && !self.editModel().FirstName()) {
                        tools.error("First Name is a required field");
                        return;
                    }
                    if (!self.editModel().CompanyName() && !self.editModel().LastName()) {
                        tools.error("Last Name is a required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveEmployee(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/Employee/GetEmployeeById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new EmployeeModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new EmployeeModel());
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'employee-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        var lookupDataSources = new LookupDataSources();
                        var employeeStatusDS = lookupDataSources.createLookupDataSource("EmployeeStatuses");
                        self.employeeStatusDropdown = $("input[name=Status]", modal).kendoDropDownList({
                            dataSource: employeeStatusDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            popup: {
                                appendTo: $(".modal-body", modal)
                            }
                        }).data("kendoDropDownList");
                        if (self.employeeStatusDropdown) {
                            self.employeeStatusDropdown.value(self.editModel().Status());
                        }
                        var employeeRolesDS = lookupDataSources.createLookupDataSource("EmployeeRoles");
                        self.employeePositionDropdown = $("input[name=Positions]", modal).kendoMultiSelect({
                            dataSource: employeeRolesDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains"
                        }).data("kendoMultiSelect");
                        if (self.employeePositionDropdown) {
                            self.employeePositionDropdown.value(self.editModel().Positions());
                        }
                    });
                }
            });
        };
        EmployeeActions.prototype.saveEmployee = function (btn, modal) {
            var self = this;
            var data = tools.modelToFormData(self.editModel());
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            data["NotesHtml"] = null;
            tools.ajaxPost({
                url: "/Employee/SaveEmployee",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.editModel().Id() > 0) {
                        if (self.afterSuccess) {
                            self.afterSuccess();
                        }
                    }
                    else {
                        window.location.href = "/Employee/Details/".concat(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        EmployeeActions.prototype.deleteEmployee = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Employee/DeleteEmployeeConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Member deleted successfully");
                    if (self.afterSuccess) {
                        self.afterSuccess();
                    }
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        EmployeeActions.prototype.deleteEmployeeConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Member",
                text: "Are you sure you want to delete member " + name + "?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteEmployee(id);
            });
        };
        return EmployeeActions;
    }());
    return EmployeeActions;
});
//# sourceMappingURL=employeeActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/employee/employeeActions.js
// module id = 92
// module chunks = 2